import { useEffect } from "react";
import PulseLoader from "react-spinners/PulseLoader";
import { Col, Container, Row } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../shared/AuthContext/AuthContext";
import { getPaymentButtonStatus } from "../../service/api";

const RedirectMidPage = () => {
  const { tenant, publicKey } = useParams();
  const { getAuthToken } = useAuth();
  const navigate = useNavigate();

  const getStatusInfoPayment = async () => {
    const accessToken = await getAuthToken();
    getPaymentButtonStatus(accessToken, tenant, publicKey).then(async (response) => {
      if (response.status == 200) {
        const responseData = await response.data;
        setTimeout(() => {
          if (responseData.urlRedirect && responseData.urlRedirect.trim()) {
            navigate("/success");
          } else {
            navigate("/error");
          }
        }, 1000);
      }
    });
  };

  useEffect(() => {
    getStatusInfoPayment();
  }, [tenant, publicKey]);

  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <Container>
        <Row className="justify-content-center align-items-center mt-5">
          <Col sm={12} className="text-center">
            <h3>Loading payment information</h3>
          </Col>
          <Col md={12} className="text-center mt-5">
            <PulseLoader color="#182a53" speedMultiplier={0.5} />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RedirectMidPage;
